import { render } from "./Breadcrumb.vue?vue&type=template&id=34688eac"
import script from "./Breadcrumb.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script